import Glide, {Controls, Swipe, Breakpoints, Autoplay} from "@glidejs/glide/dist/glide.modular.esm";
require('../../scss/app-default.scss');

import DeckPlanBehaviour from "../behaviours/deck-plan-behaviour";
import PartialBehaviour from '../behaviours/partial-behaviour';
import RecommendBehaviour from '../behaviours/recommend-behaviour';
import UrlParameterHandlerBehaviour from '../behaviours/url-parameter-handler-behaviour';
import ScrollToBehaviour from '../behaviours/scroll-to-behaviour';
import TabsBehaviour from "../behaviours/tabs-behaviour";
import HideShowBehaviour from "../behaviours/hide-show-behaviour";
import MobileMenuBehavior from "../behaviours/mobile-menu-behaviour";
import EqualizeBehavior from "../behaviours/equalize-behaviour";
import ToggleClassBehavior from "../behaviours/toggle-class-behaviour";
import ChoiceOtherBehaviour from "../behaviours/choice-other-behaviour";
import CarouselBehaviour from "../behaviours/carousel-behaviour";

import YoutubeVideo from "../jsx/video/youtube-video";
import CountDown from "../jsx/count-down";
import Gallery from "../jsx/gallery";
import SoloToggle from "../jsx/solo-toggle";
import SearchTemplateFull from "../jsx/search/template-full";
import SearchTemplateResults from "../jsx/search/template-results";
import AddressLookup from "../jsx/address-lookup/address-lookup";
import BackgroundImageBehaviour from '../behaviours/background-image-behaviour';
import ShortlistCount from '../jsx/shortlist/shortlist-count';
import ShortlistButton from '../jsx/shortlist/shortlist-button';
import ShortlistShow from '../jsx/shortlist/shortlist-show';
import ShortlistClear from "../jsx/shortlist/shortlist-clear";
import ShortlistFieldBehavior from "../behaviours/shortlist-field-behaviour";
import PlaceHolderSetterBehaviour from "../behaviours/form-field-changer-behaviour";
import EmbeddedGallery from '../jsx/embedded-gallery';
import AccordionBehaviour from "../behaviours/accordion-behaviour";
import LocalstorageFieldPopulationBehaviour from "../behaviours/localstorage-field-population-behaviour";
import ReadMoreBehaviour from "../behaviours/read-more-behaviour";
import MyRolTabsBehaviour from "../behaviours/myrol-tabs-behaviour";
import TogglePasswordBehavior from "../behaviours/togglle-password-field";
import PreferencesUpdateBehaviour from "../behaviours/preferences-update-behaviour";
import CruiseDriver from "../jsx/search/cruise-driver";
import CountdownBehavior from "../behaviours/countdown-timer-behaviour";
import DatalayerBehaviour from "../behaviours/datalayer-behaviour";
import Application from "./application";
import SelectLinkBehaviour from "../behaviours/select-link";
import HashBehaviour from "../behaviours/hash-behavior";

let config = {};
config.behaviours = {
        'PartialBehaviour': new PartialBehaviour(),
        'UrlParameterHandle': new UrlParameterHandlerBehaviour(),
        'ScrollToBehaviour': new ScrollToBehaviour(),
        'DeckPlanBehaviour': new DeckPlanBehaviour(),
        'TabsBehaviour': new TabsBehaviour(),
        'HideShowBehaviour': new HideShowBehaviour(),
        'BackgroundImageBehaviour': new BackgroundImageBehaviour(),
        'MobileMenuBehaviour': new MobileMenuBehavior(),
        'ShortlistFieldBehaviour': new ShortlistFieldBehavior(),
        'RecommendBehaviour': new RecommendBehaviour(),
        'EqualizeBehaviour': new EqualizeBehavior(),
        'PlaceHolderSetterBehaviour': new PlaceHolderSetterBehaviour(),
        'ToggleClassBehaviour': new ToggleClassBehavior(),
        'AccordionBehaviour': new AccordionBehaviour(),
        'LocalstorageFieldPopulationBehaviour': new LocalstorageFieldPopulationBehaviour(),
        'ReadMoreBehaviour': new ReadMoreBehaviour(),
        'ChoiceOtherBehaviour': new ChoiceOtherBehaviour(),
        'MyRolTabBehaviour': new MyRolTabsBehaviour(),
        'TogglePasswordBehavior': new TogglePasswordBehavior(),
        'PreferencesUpdateBehaviour': new PreferencesUpdateBehaviour(),
        'CountdownBehaviour': new CountdownBehavior(),
        'DataLayerBehaviour': new DatalayerBehaviour(),
        'SelectLinkBehaviour': new SelectLinkBehaviour(),
        'CarouselBehaviour': new CarouselBehaviour(),
        'HashBehaviour': new HashBehaviour(),
    };
config.components = {
        'youtube-video': YoutubeVideo,
        'count-down': CountDown,
        'gallery': Gallery,
        'solo-toggle': SoloToggle,
        'shortlist-count': ShortlistCount,
        'shortlist-button': ShortlistButton,
        'shortlist-show': ShortlistShow,
        'shortlist-clear': ShortlistClear,
        'search': SearchTemplateFull,
        'search-results': SearchTemplateResults,
        'embedded-gallery': EmbeddedGallery,
        'cruise-driver': CruiseDriver,
        "address-lookup": AddressLookup,
    };

// console.log('default.js@83: starting application...');
new Application(config);

window.glide = {};
if (document.querySelector('.review-slider')) {
    window.glide.reviewSlider = new Glide('.review-slider', {autoplay: false, gap: 0, perView: 2, bound: true, breakpoints: { 740: { perView: 1}  }})
        .mount({Autoplay, Controls, Breakpoints, Swipe})
        .on('run.after', () => { window.lazy.update() });
}
if(document.querySelector('.rol-timeline-slider') && document.querySelector('.rol-timeline-nav-slider')){
    window.glideTimeline = new Glide('.rol-timeline-slider', {
        perView: 1,
        gap: 10,
    }).mount({
        Controls,
        Swipe
    });

    window.glideTimelineNav = new Glide('.rol-timeline-nav-slider', {
        perView: 5,
        breakpoints: {
            1025: {
                perView: 3
            },
            640: {
                perView: 1
            },
        }
    }).mount({
        Controls,
        Breakpoints,
    });

    Array.from(document.querySelectorAll('.slide-nav')).forEach(el => {
        el.addEventListener('click', (e) => {
            window.glideTimeline.go('='+(e.currentTarget.dataset.timelineIndex));
            window.glideTimelineNav.go('='+(e.currentTarget.dataset.timelineIndex));
        })
    });

    window.glideTimelineNav.on('run', function() {
        window.glideTimelineNav.go('='+(window.glide.timeline.index))
    });

    window.glideTimelineNav.on('run.after', function() {
        window.lazy.update();
    });


    // This fixes a strange bug where the slider renders too wide. Only happens 10% of the time.
    document.addEventListener('DOMContentLoaded', function(){
        window.glideTimeline.update();
        window.glideTimelineNav.update();
    });
}
if(document.querySelector('#slider-partners')){
    window.glide.awards = new Glide('#slider-partners', {
        autoplay: 2000,
        bound: true,
        perView: 6,
        breakpoints: {
            1025: {
                perView: 3
            },
            640: {
                perView: 2
            },
            450: {
                perView: 1
            }
        }
    }).mount({
        Controls,
        Breakpoints,
        Autoplay
    });
}
if(document.querySelector('#slider-choose-us')){
    window.glide.awards = new Glide('#slider-choose-us', {
        autoplay: 2000,
        bound: true,
        perView: 7,
        breakpoints: {
            1025: {
                perView: 4
            },
            640: {
                perView: 2
            },
            450: {
                perView: 1
            }
        }
    }).mount({
        Controls,
        Breakpoints,
        Autoplay
    });
}
if(document.querySelector('#cruise-lines-carousel')){
    window.glide.cruiseLinesCarousel = new Glide('#cruise-lines-carousel', {
        autoplay: false,
        perView: 5,
        bound: true,
        breakpoints: {
            480: { perView: 1},
            600: { perView: 2},
            1025: { perView: 3}
        }
    }).mount({
        Controls,
        Breakpoints,
        Autoplay
    });

    window.glide.cruiseLinesCarousel.on('run.after', function() {
        window.lazy.update();
    });
}